<template>
  <div class="blackout">
    <div v-if="$store.state.status == null" class="popup registration profile-wrap">
      <vue-headful title="Registration | bilaskra.is" description="Registration"/>
      <div class="title"> Nýskráning
        <div class="close"><a @click.prevent="closePopup"> <img src="/img/profile/close-x.svg"/> </a></div>
      </div>
      <hr class="hr"/>
      <fb-login>Tengjast með Facebook</fb-login>  <!-- <span @click="fb_login"></span>-->
      <div class="hr-or"><span>eða</span>
        <hr class="hr"/>
      </div>
      <div class="popup-body">
        <form @keyup.enter.prevent="validateForm()">
          <div class="form-group">
            <div :class="[{ 'field-error': errors['email'] }, 'field-wrapper']">
              <input class="form-control" type="text" name="email" v-model="regFormData.email"
                     v-validate="'required|email'"/>
              <label :class="{  'filled-label':  regFormData.email && regFormData.email.length > 0  }"
                     :for="name">Netfang</label></div>
            <div v-show="errors.has('email')" class="error"> {{ errors.first("email") }}</div>
          </div>
          <div class="form-group">
            <div :class="[{ 'field-error': errors['password'] }, 'field-wrapper']">
              <input class="form-control" type="password" name="password" v-model="regFormData.password"
                     ref="password" v-validate="'required|min:6'"/>
              <label :class="{  'filled-label':  regFormData.password && regFormData.password.length > 0  }"
                     :for="name">
                Lykilorð
              </label>
            </div>
            <div v-show="errors.has('password')" class="error"> {{ errors.first("password") }}</div>
          </div>
          <div class="form-group">
            <div :class="[  { 'field-error': errors['confirm_password'] },  'field-wrapper'  ]">
              <input class="form-control" type="password" name="confirm_password"
                     v-validate="'required|confirmed:password'" data-vv-as="password"
                     v-model="confirm_password"/>
              <label :class="{  'filled-label':  confirm_password && confirm_password.length > 0  }"
                     :for="name">
                Staðfesta lykilorð
              </label>
            </div>
            <div v-show="errors.has('confirm_password')" class="error">
              {{ errors.first("confirm_password") }}
            </div>
          </div>
          <div style="clear: both;"></div>
          <div class="form-group">
                      <span class="info-span">
                        Bílaskrá.is, safnar nöfnum, netföngum og vistuð ökutæki og leit  þeirra sem innskrá sig á Bilaskra.is. Ekki fer fram kerfisbundin  eyðing á þessum upplýsingum. Sjá nánar um þær upplýsingar sem er  safnað við nýskráningu og notkun á þjónustunni, hvernig er unnið  með þær og rétt þinn til aðgangs að þeim, leiðréttingar og  eyðingar í
                        <router-link :to="{name:'AboutProject',hash:'#skilmalar_2'}">persónuverndarstefnu Bílaskrá.</router-link>
                      </span>
            <div style="margin: 15px 0px;">
              <label class="checkbox-filter-label" @click="privacy = !privacy">
                <input type="checkbox" v-model="privacy" name="Privacy" id="Privacy" v-validate="'required'"/>
                <span class="checkmark" :class="{'checked-class':privacy}"></span>
                <span class="checkbox-filter-hint">  Ég hef kynnt mér Persónuverndarstefnu Bílaskrá  </span>
              </label>
              <div v-show="errors.has('Privacy')" class="error"> {{ errors.first("Privacy") }}</div>
            </div>
          </div>
          <div>
            <!-- НЕ УДАЛЯТЬ!!-->
            <btn @click.native.prevent="validateForm()" class="btn btn-success btn-create" :load="load">
              Nýskrá
            </btn>
            <!--НЕ УДАЛЯТЬ!!-->
            <!--                        <input type="submit" @click.prevent="validateForm()" class="btn btn-success btn-create"-->
            <!--                               value="Nýskrá" />-->
          </div>
        </form>
      </div>
      <hr class="hr"/>
      <div class="footer">
        Ertu þegar notandi?
        <a @click.prevent="$store.state.popup = 'sign-in'"> Innskráning er hér</a>
      </div>
    </div>
    <pop-up v-if="$store.state.status == 'confirm-email'" :title="'Confirm e-mail'"
            :desc="'We sent you e-mail please click on the link to activate your account'"
            :btn="{ title: 'Go to sign in', popup: 'sign-in' }" :icon="'email.svg'"/>
  </div>
</template>

<script>
// import func from "../func";
import PopUp from "./PopUpSuccess.vue";
import PreloadBtn from "../PreloadBtn.vue";
import FbLogin from "../FbLogin.vue";

export default {
  components: {
    btn: PreloadBtn,
    PopUp,
    FbLogin
  },
  data: function () {
    return {
      regFormData: {
        email: null,
        password: null
      },
      load: false,
      privacy: false,
      lol: false,
      confirm_password: null,
      name: ""
    };
  },
  methods: {
    closePopup: function () {
      if (this.$route.path == "/register") {
        this.$router.push("/");
      } else {
        this.$store.state.popup = null;
      }
    },
    sendReg() {
      let api = this.$store.state.api;
      this.load = true;
      this.$http
          .post(`${api}/user/reg`, this.regFormData)
          .then(function (response) {
            this.load = false;
            if (response.body.status == "OK") {
              this.$store.state.status = "confirm-email";
            }

            if (response.body.error) {

              // let resp = [];
              for (let k in response.body.error) {
                let s = "";
                if (typeof response.body.error[k] == "object") {
                  for (let kk in response.body.error[k]) {
                    s += response.body.error[k][kk];
                    this.$validator.errors.add({
                      field: k,
                      msg: s
                    });
                  }
                  // console.log(response.body.error[k], typeof (response.body.error[k]));
                }
                // resp[k] = s;
              }
              // th.errors = resp;
            }
          })
          .catch(function (response) {
            //handle error
            // console.log(response);
          });
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          return this.sendReg();
        }
      });
    }
  }
};
</script>
